module.exports = __webpack_public_path__ + "static/media/41493 - 7853742 Canada Inc - NOP.64af13cd.pdf";